import React, {useState, useEffect} from 'react'
import * as PropTypes from 'prop-types'
import {useTranslation} from '@modifi/plugin-i18n'
import {InferPropTypes} from '@modifi/typescript-utils'
import {lightGray} from '@modifi/colors'
import {SearchIcon, SelectPure} from '@modifi/ui'
import {search, searchCompany} from './search-function'

const SearchSelect = (props: any) => (
  <SelectPure
    autoFocus
    components={{
      DropdownIndicator: () => <SearchIcon height={24} width={24} color={lightGray} />,
    }}
    async
    {...props}
  />
)

type OptionType = {
  value: string
  label: string
}

const propTypes = {
  onChange: PropTypes.func.isRequired,
  minLength: PropTypes.number,
  allowCompanyNameSearch: PropTypes.bool.isRequired,
}

const defaultProps = {
  minLength: 3,
}

type SearchInputProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const SearchInput: React.FC<SearchInputProps> = ({onChange, minLength, allowCompanyNameSearch}) => {
  const [value, setValue] = useState<OptionType | null>()
  const [fetchedOptions, setFetchedOptions] = useState<OptionType[]>([])
  const {t} = useTranslation('ui')
  useEffect(() => {
    if (allowCompanyNameSearch) {
      setValue(null)
    }
  }, [allowCompanyNameSearch])

  const handleSelectChange = async (option: OptionType) => {
    setValue(option)
    const userEmails = await searchCompany(option?.value)
    onChange(userEmails)
  }

  const loadNewOptions = (inputValue: string, callback: any) => {
    if (inputValue.length >= minLength!)
      return search(inputValue).then((opt: OptionType[]) => {
        setFetchedOptions(opt)
        callback(opt)
      })
    return new Promise(resolve => resolve([]))
  }

  return (
    <>
      <SearchSelect
        loadOptions={loadNewOptions}
        noOptionsMessage={({inputValue}: {inputValue: string}) =>
          inputValue.length < minLength!
            ? t('filters.search-filter-form.min-length-message.text', {
                requiredCharactersCount: minLength! - inputValue.length,
              })
            : t('filters.search-filter-form.no-results.text')
        }
        onChange={handleSelectChange}
        defaultOptions={fetchedOptions}
        placeholder={t('filters.search-filter-form.placeholder')}
        value={value}
        disabled={!allowCompanyNameSearch}
        name="search-company"
      />
    </>
  )
}

SearchInput.propTypes = propTypes
SearchInput.defaultProps = defaultProps

export default SearchInput
